module.exports = function() {
  return new Worker(__webpack_public_path__ + "ee29604de2e30d8c.worker.js");
};